/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const ControllingIcon = /*#__PURE__*/ createSvgIcon(
  'ControllingIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1.646 1.647a.5.5 0 01.485-.13l12.69 3.45a.5.5 0 01.223.837L12.227 8.62l6.127 6.137a.5.5 0 01-.001.707l-2.88 2.87a.5.5 0 01-.706 0L8.63 12.207l-2.816 2.817a.5.5 0 01-.836-.222l-3.46-12.67a.5.5 0 01.128-.485zm1.067 1.065l3.002 10.995 2.561-2.56a.5.5 0 01.707 0l6.137 6.127 2.173-2.165-6.127-6.136a.5.5 0 010-.707l2.56-2.56L2.714 2.712z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default ControllingIcon;
